import { Injectable, ComponentFactoryResolver, Injector, ApplicationRef } from '@angular/core';
import * as L from 'leaflet';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ICoolersDetails } from '../Models/ICoolersDetails';
import { label } from '../constants/labels';
import { I18nService } from '@app/core/i18n.service';

const initialZoom = 9;
const maxZoom = 18;
const shadowUrl = 'assets/marker-shadow.png';
@Injectable()
export class MapService {

  private _map: any | null;
  labels: any;
  lang: string;
  public injector: Injector;
  public appRef: ApplicationRef;
  public resolver: ComponentFactoryResolver;
  public compRef: any;
  public component: any;
  public markerShow: any;
  constructor(private readonly http: HttpClient, private readonly router: Router, private readonly translate1: TranslateService, private readonly i18Service: I18nService) { }

  public initMap(mapid: string) {

    this.labels = label;
    this.lang = this.i18Service.language;
    if (this._map) {
      this._map.remove();
    }
    this._map = new L.Map(mapid, { attributionControl: false });
    // switch off unneeded features for better performance
    this._map.addLayer(new L.TileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: maxZoom,
        minZoom: 1,
        maxNativeZoom: 19,
        noWrap: true,
        updateWhenIdle: true,
      }
    ));
  }

  get selectedLocation(): any {
    return JSON.parse(sessionStorage.getItem("location"));
  }


  //Map Icons
  private readonly inactiveIcon: L.Icon = new L.Icon({
    iconUrl: 'assets/marker-icon-2x-gray.png',
    shadowUrl: shadowUrl,
    iconSize: [28, 32],
    iconAnchor: [12.5, 41]
  });

  private readonly lowSeverityIcon: L.Icon = new L.Icon({
    iconUrl: 'assets/MapPin1.svg',
    shadowUrl: shadowUrl,
    iconSize: [28, 32],
    iconAnchor: [12.5, 41]
  });

  private readonly medSeverityIcon: L.Icon = new L.Icon({
    iconUrl: 'assets/MapPin2.svg',
    shadowUrl: shadowUrl,
    iconSize: [28, 32],
    iconAnchor: [12.5, 41]
  });

  private readonly highSeveritIcon: L.Icon = new L.Icon({
    iconUrl: 'assets/MapPin3.svg',
    shadowUrl: shadowUrl,
    iconSize: [28, 32],
    iconAnchor: [12.5, 41]
  });

  //Icon based on status
  private getIcon(severity: number) {
    let icon: L.Icon;
    const s: number = severity;
    switch (s) {
      case 1: {
        icon = this.highSeveritIcon;
        break;
      }
      case 2: {
        icon = this.medSeverityIcon;
        break;
      }

      default: {
        icon = this.lowSeverityIcon;
        break;
      }

    }
    return icon;
  }

  addCoolersMarker(coolers: ICoolersDetails[]) {
    for (const cooler of coolers) {
      const marker = new L.Marker([cooler.latitude, cooler.longitude], { icon: this.getIcon(cooler.alarm_Severity), riseOnHover: true })
        .bindPopup(`<div><b>${this.translate1.instant(this.labels.tableHeaderDevice)}: ${cooler.name}</b>
            <hr>
            </div>
            <div>
              <table class="info-table">
                <tbody>
                  <tr>
                    <td class="text-right" >${this.translate1.instant(this.labels.activeAlarms)}</td>
                    <td> : </td><td class="text-left text-bold">${cooler.alarms_Count} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            `).openPopup();
      marker.addTo(this._map);
    }
    if (coolers) {
      this._map.setView([coolers[0].latitude, coolers[0].longitude], initialZoom);
    }
  }

  locate(latitude: number, longitude: number, cooler: any) {
    if (cooler) {
      const marker = new L.Marker([cooler.latitude, cooler.longitude], { icon: this.getIcon(cooler.alarm_Severity), riseOnHover: true })
        .bindPopup(`<div><b>${this.translate1.instant(this.labels.tableHeaderDevice)}: ${cooler.name}</b>
            <hr>
            </div>
            <div>
              <table class="info-table">
                <tbody>
                  <tr>
                    <td class="text-right" >${this.translate1.instant(this.labels.activeAlarms)}</td>
                    <td> : </td><td class="text-left text-bold">${cooler.alarms_Count} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            `).openPopup();
      marker.addTo(this._map);
      marker.togglePopup();

    }
  }

}
